import { useState } from "react";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import LaunchIcon from "@mui/icons-material/Launch";
import LinkIcon from "@mui/icons-material/Link";
import CheckIcon from "@mui/icons-material/Check";

export default function CopyAndVisitIconsBtns({
  link = window.location.href,
  subLink,
  sx,
}) {
  const [copied, setCopied] = useState(false);
  const [opened, setOpened] = useState(false);

  const url = subLink ? window.location.origin + subLink : link;

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error("Failed to copy:", err);
    }
  };

  const handleOpen = () => {
    window.open(url, "_blank");
    setOpened(true);
    setTimeout(() => setOpened(false), 2000);
  };

  return (
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "center",
        border: "1px solid",
        // borderColor: "primary.main",
        borderColor: "default",
        borderRadius: 2,
        bgcolor: "background.paper",
        color: "text.secondary",
        "& svg": {
          mx: 0.5,
          my: 0,
        },
        ...sx,
      }}
    >
      {/* Copy Button */}
      <Tooltip placement="top" arrow title={copied ? "Copied!" : "Copy link"}>
        <IconButton
          // onClick={handleCopy}
          color={copied ? "success" : "primary"}
          size="small"
        >
          {copied ? <CheckIcon /> : <LinkIcon />}
        </IconButton>
      </Tooltip>

      <Divider
        orientation="vertical"
        variant="middle"
        flexItem
        sx={{ backgroundColor: "primary.main" }}
      />

      {/* Open Button */}
      <Tooltip placement="top" arrow title={opened ? "Opened!" : "Open link"}>
        <IconButton
          // onClick={handleOpen}
          color={opened ? "success" : "primary"}
          size="small"
        >
          <LaunchIcon />
        </IconButton>
      </Tooltip>
    </Box>
  );
}
